/* eslint-disable react-hooks/exhaustive-deps */
import { Col, Input } from "reactstrap";
import { LI, SVG, UL } from "../../../AbstractElements";
import { ChangeEvent, useEffect, useState } from "react";
import { MenuItem, SearchSuggestionItem, SubMenuType } from "../../../types/layout/SidebarType";
import ResponsiveSearchList from "./ResponsiveSearchList";
import { useTranslation } from "react-i18next";
import { useMenuList } from "../../../data/layout-data/useMenuList";

const SearchInput = () => {
  const [arr, setArr] = useState<SearchSuggestionItem[]>([]);
  const [searchedWord, setSearchedWord] = useState<string>("");
  const [searchedArray, setSearchedArray] = useState<SearchSuggestionItem[]>([]);
  const { t } = useTranslation();
  const menuList = useMenuList();

  useEffect(() => {
    const suggestionArray: SearchSuggestionItem[] = [];
    const getAllLink = (item: SubMenuType, icon: string | undefined) => {
      if (item.children) {
        item.children.forEach((ele: SubMenuType) => {
          getAllLink(ele, icon);
        });
      } else {
        suggestionArray.push({
          icon,
          title: item.title,
          path: item.path || "",
        });
      }
    };
    menuList.forEach((item: MenuItem) => {
      item.Items?.forEach((child: SubMenuType) => {
        getAllLink(child, child.icon);
      });
    });
    setArr(suggestionArray);
  }, [menuList]);

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchedWord(e.target.value);
    const result = arr.filter((item) =>
      item.title?.toLowerCase().includes(e.target.value.toLowerCase())
    );
    setSearchedArray(result);
  };

  return (
    <Col
      xxl="5"
      md="3"
      className="left-header col-auto box-col-6 horizontal-wrapper p-0"
    >
      <div className="left-menu-header">
        <UL className="header-left simple-list">
          <LI>
            <div className="form-group w-100">
              <div className="Typeahead Typeahead--twitterUsers">
                <div className="u-posRelative d-flex">
                  <SVG
                    className="search-bg svg-color me-2"
                    iconId="fill-search"
                  />
                  <Input
                    className="demo-input Typeahead-input form-control-plaintext w-100 p-0"
                    type="text"
                    placeholder={t("SearchAny")}
                    name="q"
                    value={searchedWord}
                    onChange={handleSearch}
                  />
                </div>
                <div
                  className={`Typeahead-menu custom-scrollbar ${
                    searchedWord.length ? "is-open" : ""
                  }`}
                >
                  <ResponsiveSearchList
                    searchedArray={searchedArray}
                    setSearchedWord={setSearchedWord}
                  />
                </div>
              </div>
            </div>
          </LI>
        </UL>
      </div>
    </Col>
  );
};

export default SearchInput;